import PropTypes from 'prop-types';

export default PropTypes.shape({
  actionType: PropTypes.string,
  username: PropTypes.string,
  office: PropTypes.string,
  date: PropTypes.string,
  actions: PropTypes.arrayOf(PropTypes.string)
});
